;(function (global, factory) {
    typeof define === 'function' && define.amd ? define('score_bootstrap/Components/CarouselPane',["jquery", "eventManager", 'loglevel'], factory) :
    typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory(require("jquery"), require("eventManager"), require('loglevel')) :
    console && console.error('CarouselPane does not support non-amd script loading.');
}(this/* window */, function ($, eventManager, log) {

    function CarouselPane(scope, selectActionMessages) {
        var self = this;
        Object.defineProperty(this, "$scope", { enumerable: true, value: $(scope) });

        //#region select on mesage performer
        if (selectActionMessages.length) {
            selectActionMessages.forEach(function (messageName) {
                eventManager.subscribe(messageName, self.makeActive, self);
            });
        }
        //#endregion
    }

    CarouselPane.prototype.makeActive = function () {
        var carousel = this.$scope.closest('.carousel');

        if (!carousel) {
            log.error("Cannot detect carousel element. Carousel panel selection canceled.");
            return !1;
        }

        var index = carousel.find('.carousel-inner > .item').index(this.$scope);
        carousel.carousel(index);
    };


    CarouselPane.init = function init(args) {
        return args.IsEditorEditing === true
            ? null
            : new CarouselPane(args.scope, args.SelectActionMessages || []);
    };

    return CarouselPane;
}));
